<template>
    <div>
        <div class="container mt-4" style="margin-bottom:9rem">
            <boton-atras nombre_ruta="menuQuienesSomos"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">¿Quiénes Somos?</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <router-link :to="{name: 'somosfoprovep'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5> ¿Qué es el FOPROVEP </h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>      
                    <router-link :to="{name: 'mision-vision'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5> Misión y Visión </h5>
                                </div> 
                            </div> 
                        </div>
                    </router-link>
                    <router-link :to="{name: 'organigrama'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5> Organigrama </h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>      
                    <router-link :to="{name: 'proposito-areas'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5> Propósito de las áreas </h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>
                    <router-link :to="{name: 'comite-tecnico'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5> H. Comité Técnico </h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>      
                </div>
                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/foprovep/somos.jpg" alt="">  
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // Variables
        }
    },
    components:{
        botonAtras,
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
}

</style>